import { __assign, __awaiter, __extends, __generator } from "tslib";
import React, { Component, useState } from 'react';
import { View, StyleSheet, TouchableOpacity, Image, Linking, Text } from 'react-native';
import { PnmacText, PnmacMediaQuery, PnmacPaper, PnmacTextInput, PnmacUIButton, PnmacHtmlToNative, theme, PnmacModal } from 'pnmac-universal-components';
import { connect } from "react-redux";
import moment from 'moment';
import { bindActionCreators } from "redux";
import { RuleId, currencyFormatter, ammountPaymentAhead, genericStatusCheck, getActiveFeatures, checkForAllNumbersCurrency, testID, encryptBankAccountNumber } from '../../../../utils.js';
import { textStyle } from '../../../../v2/theme/index.js';
import PnmacActivityIndicator from '../../../../PnmacActivityIndicator/index.js';
import BannerView from '../../../../v2/BannerView/index.js';
import moments from 'moment';
import { PAYMENT_VALIDATION } from '../../../../redux/actions/actions.js';
var imageAssets = {
  closeIcon: require('../../../../assets/icon-close-x-darkGray.png')
};
String.prototype.countDecimals = function () {
  var numStr = String(this.valueOf());
  if (numStr.includes('.')) {
    return numStr.split('.')[1].length;
  }
  ;
  return 0;
};
var Toogle = function (props) {
  var _a = useState(props.value || false),
    isOn = _a[0],
    setIsOn = _a[1];
  function toggleSwitch() {
    if (!props.disabled) {
      setIsOn(!isOn);
      if (props.onValueChange) {
        props.onValueChange(!isOn);
      }
    }
  }
  return /*#__PURE__*/React.createElement(View, {
    style: styles.togglecontainer
  }, /*#__PURE__*/React.createElement(TouchableOpacity, {
    disabled: props.disabled,
    style: [styles.outer, {
      justifyContent: props.value ? 'flex-end' : 'flex-start',
      backgroundColor: props.value ? '#105BFB' : '#6B6B6B'
    }, props.disabled && styles.disabled],
    activeOpacity: 1,
    onPress: toggleSwitch
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.inner
  })));
};
var SetupAutoPay = /** @class */function (_super) {
  __extends(SetupAutoPay, _super);
  function SetupAutoPay(props) {
    var _this = this;
    var _a, _b;
    _this = _super.call(this, props) || this;
    _this.replaceDollarSign = function (value) {
      var _a;
      return (_a = value === null || value === void 0 ? void 0 : value.toString()) === null || _a === void 0 ? void 0 : _a.replace("$", "").replace(",", "");
    };
    _this.onChange = function (value, property) {
      var _a;
      if (checkForAllNumbersCurrency(value)) {
        _this.setState({
          payment: __assign(__assign({}, _this.state.payment), (_a = {}, _a[property] = value, _a))
        }, function () {
          _this.setState({
            payment: __assign(__assign({}, _this.state.payment), {
              totalDraftAmount: _this.totalDraftAmountFun()
            })
          });
        });
      }
    };
    _this.checkPaymentOver = function () {
      var _a, _b;
      var _c = (_a = _this.props.layout) === null || _a === void 0 ? void 0 : _a.currentLoan,
        unpaidPrincipalBalanceAmount = _c.unpaidPrincipalBalanceAmount,
        currentTotalMonthlyPaymentAmount = _c.currentTotalMonthlyPaymentAmount;
      var totalNew = parseFloat(unpaidPrincipalBalanceAmount || 0) - (parseFloat(currentTotalMonthlyPaymentAmount) + (((_b = _this.props.layout.paymentModel) === null || _b === void 0 ? void 0 : _b.pendingPayments) || []).reduce(function (a, b) {
        return a + b.totalDraftAmount;
      }, 0));
      var currentbal = _this.totalDraftAmountFun(true);
      if (currentbal >= totalNew || currentbal >= 99999.99) {
        return true;
      }
      return false;
    };
    _this.disableSubmitButton = function () {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
      var layout = _this.props.layout;
      var accountNumber = (((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.bankAccount) || ((_c = (_b = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _b === void 0 ? void 0 : _b.payment) === null || _c === void 0 ? void 0 : _c.bankAccount) || {}).accountNumber;
      var _q = _this.state,
        edit = _q.edit,
        originalNextPaymentDueDate = _q.originalNextPaymentDueDate;
      var status = (_d = layout.selectedLoanAvailability) === null || _d === void 0 ? void 0 : _d.status;
      var modifications = layout.modifications;
      var isTrialPaymentVisible = modifications === null || modifications === void 0 ? void 0 : modifications.isTrialPaymentVisible;
      var currentTime = moment(layout.localTime);
      var checkDate = ((_e = _this.state) === null || _e === void 0 ? void 0 : _e.effectiveDate) && moment((_f = _this.state) === null || _f === void 0 ? void 0 : _f.effectiveDate).date() > 16;
      var selectedDate = !((_g = _this.state) === null || _g === void 0 ? void 0 : _g.effectiveDate);
      var dueDate = moment(layout.currentLoan.nextPaymentDueDate);
      var currentPayment = (_j = (_h = layout.paymentModel) === null || _h === void 0 ? void 0 : _h.pendingPayments) === null || _j === void 0 ? void 0 : _j.find(function (s) {
        return s.paymentType == 201309;
      });
      var effectiveDate = typeof ((_k = _this.state) === null || _k === void 0 ? void 0 : _k.effectiveDate) === 'object' ? moment((_l = _this.state) === null || _l === void 0 ? void 0 : _l.effectiveDate, 'MM/DD/YYYY').format('YYYY-MM-DDTHH:mm:ss') : (_m = _this.state) === null || _m === void 0 ? void 0 : _m.effectiveDate;
      var isEdited = (currentPayment === null || currentPayment === void 0 ? void 0 : currentPayment.effectiveDate) != effectiveDate || (currentPayment === null || currentPayment === void 0 ? void 0 : currentPayment.additionalPrincipalAmount) != ((_o = _this.state.payment) === null || _o === void 0 ? void 0 : _o.additionalPrincipalAmount);
      var paymentWindow = !edit && (ammountPaymentAhead(status, 2) || (getActiveFeatures(layout.features, "BRMS_Delinquent", layout.whitelisted) ? false : ((_p = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _p === void 0 ? void 0 : _p.numberofPendingPayments) >= 2) || moment(originalNextPaymentDueDate).isAfter(moment(layout.localTime)) && moment([dueDate.year(), dueDate.month(), dueDate.date()]).diff(moment([currentTime.year(), currentTime.month(), dueDate.date()]), 'months', true) > 2);
      return !isEdited || checkDate || _this.checkPaymentOver() || selectedDate || accountNumber == null || paymentWindow && isTrialPaymentVisible || _this.totalDraftAmountFun() <= 0;
    };
    _this.getDate = function (labelValue) {
      var _a, _b, _c, _d, _e, _f, _g;
      var translations = _this.props.translations;
      if (!labelValue || labelValue > 16) return 'Select Date';
      if (labelValue === 1) {
        label = translations.FirstOfMonth;
      } else if (labelValue === 2) {
        label = translations.SecondOfMonth;
      } else if (labelValue === 3) {
        label = translations.ThirdOfMonth;
      } else {
        label = (_a = translations === null || translations === void 0 ? void 0 : translations.RestOfMonth) === null || _a === void 0 ? void 0 : _a.replace('{{selectedDate}}', labelValue);
      }
      if (((_c = (_b = _this.props.route) === null || _b === void 0 ? void 0 : _b.params) === null || _c === void 0 ? void 0 : _c.AutoPayDate) && ((_e = moment((_d = _this.state) === null || _d === void 0 ? void 0 : _d.effectiveDate)) === null || _e === void 0 ? void 0 : _e.date()) !== ((_g = (_f = _this.props.route) === null || _f === void 0 ? void 0 : _f.params) === null || _g === void 0 ? void 0 : _g.AutoPayDate)) {
        _this.getEffectiveDate();
      }
      return label;
    };
    _this.totalFees = function () {
      var _a, _b, _c, _d, _e, _f;
      var bankAccountType = (_b = (_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.bankAccount) === null || _b === void 0 ? void 0 : _b.bankAccountType;
      return ((_f = (_e = (_d = (_c = _this.state) === null || _c === void 0 ? void 0 : _c.payment) === null || _d === void 0 ? void 0 : _d.feesDues) === null || _e === void 0 ? void 0 : _e.filter(function (s) {
        return s.fieldName.indexOf("Income") == -1 && s.fieldName.indexOf("Corportate") == -1;
      })) === null || _f === void 0 ? void 0 : _f.reduce(function (accumulator, currentValue) {
        var _a, _b, _c;
        if (((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.paymentType) != 201298 && ((_b = _this.state.payment) === null || _b === void 0 ? void 0 : _b.paymentType) != 201299 && ((_c = _this.state.payment) === null || _c === void 0 ? void 0 : _c.paymentType) != 201311 && parseInt(bankAccountType) != 201288) {
          return accumulator;
        }
        if (currentValue.fieldName == "debitCardConvenienceFee" && parseInt(bankAccountType) != 201288) {
          return accumulator;
        }
        return accumulator + parseFloat(_this.replaceDollarSign(currentValue.feeAmtField));
      }, 0)) || 0;
    };
    _this.totalDraftAmountFun = function (submit) {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9;
      var deliquentPayment = _this.state.deliquentPayment;
      if (((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.paymentType) == 1000145 || ((_b = _this.state.payment) === null || _b === void 0 ? void 0 : _b.paymentType) == 1000146) {
        return parseFloat(_this.replaceDollarSign((_c = _this.state.payment) === null || _c === void 0 ? void 0 : _c.forbearanceAmount)) || 0;
      }
      var totalDraftAmount = (parseFloat(_this.totalFees()) || 0) + (parseFloat(_this.replaceDollarSign((_d = _this.state.payment) === null || _d === void 0 ? void 0 : _d.additionalEscrowAmount)) || 0) + (parseFloat(_this.replaceDollarSign((_e = _this.state.payment) === null || _e === void 0 ? void 0 : _e.additionalPrincipalAmount)) || 0) + (((_f = _this.props.layout.paymentModel) === null || _f === void 0 ? void 0 : _f.mustMakeDelinquentPayment) && _this.props.layout.paymentModel.numberofPendingPayments == 0 ? parseFloat(_this.replaceDollarSign((_g = _this.state.payment) === null || _g === void 0 ? void 0 : _g.delinquentPaymentAmount)) || 0 : parseFloat(_this.replaceDollarSign((_k = (_j = (_h = _this.props) === null || _h === void 0 ? void 0 : _h.layout.paymentModel) === null || _j === void 0 ? void 0 : _j.payment) === null || _k === void 0 ? void 0 : _k.monthlyPaymentAmount)) || 0);
      if (deliquentPayment) {
        totalDraftAmount = (parseFloat(_this.totalFees()) || 0) + (parseFloat(_this.replaceDollarSign((_l = _this.state.payment) === null || _l === void 0 ? void 0 : _l.additionalEscrowAmount)) || 0) + (parseFloat(_this.replaceDollarSign((_m = _this.state.payment) === null || _m === void 0 ? void 0 : _m.additionalPrincipalAmount)) || 0) + (parseFloat(_this.replaceDollarSign((_q = (_p = (_o = _this.props) === null || _o === void 0 ? void 0 : _o.layout.paymentModel) === null || _p === void 0 ? void 0 : _p.payment) === null || _q === void 0 ? void 0 : _q.monthlyPaymentAmount)) || 0) + (parseFloat(_this.replaceDollarSign((_r = _this.state.payment) === null || _r === void 0 ? void 0 : _r.delinquentPaymentAmount)) || 0);
      }
      if (((_s = _this.state.payment) === null || _s === void 0 ? void 0 : _s.paymentType) == 201311) {
        totalDraftAmount = (parseFloat(_this.totalFees()) || 0) + (parseFloat(_this.replaceDollarSign((_t = _this.state.payment) === null || _t === void 0 ? void 0 : _t.additionalEscrowAmount)) || 0) + (parseFloat(_this.replaceDollarSign((_u = _this.state.payment) === null || _u === void 0 ? void 0 : _u.additionalPrincipalAmount)) || 0) + (parseFloat((_w = (_v = _this.state.payment) === null || _v === void 0 ? void 0 : _v.delinquentPayments) === null || _w === void 0 ? void 0 : _w.filter(function (s) {
          return s.selected && !s.paid;
        }).reduce(function (a, o) {
          return a += parseFloat(o.paymentAmount);
        }, 0)) || 0);
      }
      // add principle
      if (((_x = _this.state.payment) === null || _x === void 0 ? void 0 : _x.paymentType) == 201297) {
        totalDraftAmount = parseFloat(_this.replaceDollarSign((_y = _this.state.payment) === null || _y === void 0 ? void 0 : _y.additionalPrincipalAmount)) || 0;
      }
      // add escrow
      if (((_z = _this.state.payment) === null || _z === void 0 ? void 0 : _z.paymentType) == 201299) {
        totalDraftAmount = (parseFloat(_this.totalFees()) || 0) + (parseFloat(_this.replaceDollarSign((_0 = _this.state.payment) === null || _0 === void 0 ? void 0 : _0.additionalEscrowAmount)) || 0);
      }
      // ach
      if (((_1 = _this.state.payment) === null || _1 === void 0 ? void 0 : _1.paymentType) == 201309) {
        totalDraftAmount = (parseFloat(_this.replaceDollarSign((_2 = _this.state.payment) === null || _2 === void 0 ? void 0 : _2.additionalPrincipalAmount)) || 0) + (parseFloat(_this.replaceDollarSign((_5 = (_4 = (_3 = _this.props) === null || _3 === void 0 ? void 0 : _3.layout.paymentModel) === null || _4 === void 0 ? void 0 : _4.payment) === null || _5 === void 0 ? void 0 : _5.monthlyPaymentAmount)) || 0);
      }
      // Trial Payment
      if (((_6 = _this.state.payment) === null || _6 === void 0 ? void 0 : _6.paymentType) == 201296) {
        totalDraftAmount = parseFloat(_this.replaceDollarSign((_9 = (_8 = (_7 = _this.props) === null || _7 === void 0 ? void 0 : _7.layout.paymentModel) === null || _8 === void 0 ? void 0 : _8.payment) === null || _9 === void 0 ? void 0 : _9.monthlyPaymentAmount)) || 0;
      }
      return totalDraftAmount;
    };
    _this.submitPayment = function () {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
      var _p = _this.props,
        layout = _p.layout,
        isOtp = _p.isOtp,
        holdViewOpen = _p.holdViewOpen,
        refreshSingleLoanData = _p.refreshSingleLoanData;
      var bankAccountType = ((_a = _this.state.payment.bankAccount) !== null && _a !== void 0 ? _a : (_d = (_c = (_b = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _b === void 0 ? void 0 : _b.payment) === null || _c === void 0 ? void 0 : _c.bankAccount) === null || _d === void 0 ? void 0 : _d.bankAccountType).bankAccountType;
      var edit = _this.state.edit;
      _this.setState({
        isLoading: true
      });
      if (parseInt(layout.selectedLoanNumber) > 0) {
        _this.setState({
          paymentSubmitted: true
        });
        var payment_1 = _this.state.payment;
        payment_1.bankAccount = _this.props.layout.paymentModel.payment.bankAccount;
        payment_1.loan = layout.currentLoan;
        payment_1.loanId = layout.selectedLoanNumber;
        payment_1.totalDraftAmount = _this.totalDraftAmountFun(true);
        payment_1.doubleMonthlyPaymentAmount = _this.replaceDollarSign(payment_1.doubleMonthlyPaymentAmount);
        if ((_e = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _e === void 0 ? void 0 : _e.mustMakeDelinquentPayment) {
          if (layout.paymentModel.numberofPendingPayments > (edit ? ((_g = (_f = layout.paymentModel) === null || _f === void 0 ? void 0 : _f.payment) === null || _g === void 0 ? void 0 : _g.totalDraftAmount) >= parseFloat(payment_1 === null || payment_1 === void 0 ? void 0 : payment_1.delinquentPaymentAmount) + _this.totalFees() ? 0 : 1 : 0)) {
            payment_1.monthlyPaymentAmount = payment_1.delinquentMonthlyPaymentAmount;
            payment_1.dueDate = payment_1.nextDelinquentPaymentDate;
          } else {
            payment_1.monthlyPaymentAmount = payment_1.delinquentPaymentAmount;
            payment_1.dueDate = payment_1.delinquentPaymentDueDate;
          }
        }
        Object.keys(payment_1).map(function (s) {
          if ("suspenseAmount,monthlyPaymentAmount,totalFeesAmount,additionalEscrowAmount,delinquentPaymentAmount,additionalPrincipalAmount".indexOf(s) > -1) {
            payment_1[s] = isNaN(_this.replaceDollarSign(payment_1[s])) ? 0.00 : _this.replaceDollarSign(payment_1[s]);
          }
        });
        if (payment_1.paymentType == 201297 && ((_h = payment_1 === null || payment_1 === void 0 ? void 0 : payment_1.feesDues) === null || _h === void 0 ? void 0 : _h.find(function (s) {
          return s.fieldName == "debitCardConvenienceFee";
        }))) {
          var indexdebit = payment_1.feesDues.findIndex(function (s) {
            return s.fieldName == "debitCardConvenienceFee";
          });
          payment_1.feesDues.splice(indexdebit, 1);
        }
        if (parseInt(bankAccountType) != 201288 && ((_j = payment_1 === null || payment_1 === void 0 ? void 0 : payment_1.feesDues) === null || _j === void 0 ? void 0 : _j.find(function (s) {
          return s.fieldName == "debitCardConvenienceFee";
        }))) {
          var index = payment_1.feesDues.findIndex(function (s) {
            return s.fieldName == "debitCardConvenienceFee";
          });
          payment_1.feesDues.splice(index, 1);
        }
        if (((_k = payment_1 === null || payment_1 === void 0 ? void 0 : payment_1.feesDues) === null || _k === void 0 ? void 0 : _k.length) > 0) {
          payment_1.feesDues = payment_1 === null || payment_1 === void 0 ? void 0 : payment_1.feesDues.filter(function (s) {
            return parseFloat(s.feeAmtField) > 0;
          });
          payment_1.feesDues.forEach(function (d) {
            return delete d._feeAmtField;
          });
        }
        if (!isOtp) {
          payment_1.draftSource = 4;
        }
        payment_1.effectiveDate = moment(_this.state.effectiveDate, "MM/DD/YYYY").isValid() ? moment(_this.state.effectiveDate, "MM/DD/YYYY").format("MM/DD/YYYY") : moment(_this.state.effectiveDate).format("MM/DD/YYYY");
        payment_1.mobile = layout.mobile;
        if (_this.state.cancelModalOpen) {
          var payy_1 = (_m = (_l = layout.paymentModel) === null || _l === void 0 ? void 0 : _l.pendingPayments) === null || _m === void 0 ? void 0 : _m.find(function (s) {
            return s.paymentType == 201309;
          });
          _this.setState({
            isLoading: true,
            cancelModalOpen: false,
            cancelAutopay: false
          });
          fetch("".concat(layout.pennyHomeUrl, "api/payment/").concat(parseInt((_o = _this.state.payment) === null || _o === void 0 ? void 0 : _o.draftSource) == 4 ? "delete_ach" : "delete_payment"), {
            method: 'POST',
            headers: {
              "Content-Type": "application/json; charset=utf-8",
              "Authorization": "Bearer ".concat(_this.props.layout.token),
              "TrackerSessionId": "".concat(_this.props.layout.trackerSession)
            },
            body: JSON.stringify(__assign(__assign({}, payy_1), {
              bankAccount: __assign(__assign({}, payy_1.bankAccount), {
                unmaskedAccountNumber: undefined,
                confirmAccountNumber: undefined,
                confirmAccountNumberEncode: encryptBankAccountNumber(payy_1.bankAccount.confirmAccountNumber)
              }),
              loan: layout.currentLoan
            }))
          }).then(function (res) {
            return res.json();
          }).then(function (data) {
            var _a, _b, _c, _d;
            if (data && (((_a = Object.keys(data === null || data === void 0 ? void 0 : data.errors)) === null || _a === void 0 ? void 0 : _a.length) == 0 || !(data === null || data === void 0 ? void 0 : data.errors))) {
              var newPaymentModel = __assign({}, layout.paymentModel);
              var p = (_b = layout.paymentModel) === null || _b === void 0 ? void 0 : _b.pendingPayments.findIndex(function (s) {
                return s.achConfigurationKey == payy_1.achConfigurationKey;
              });
              newPaymentModel.pendingPayments.splice(p, 1);
              _this.props.dispatch({
                type: PAYMENT_VALIDATION,
                payment: newPaymentModel
              }, function () {
                return _this.props.refreshBankData(layout.selectedLoanNumber);
              });
              if (!layout.mobile) {
                if (parseInt((_c = _this.state.payment) === null || _c === void 0 ? void 0 : _c.draftSource) == 4) {
                  windowObject.dataLayer = windowObject.dataLayer || [];
                  dataLayer.push({
                    event: 'ach_canceled'
                  });
                }
              }
            }
            _this.setState({
              isMounted: false,
              openedTerms: false,
              page: "pay",
              openCancelAch: false,
              payment: __assign(__assign({}, __assign(__assign({}, (_d = layout.paymentModel) === null || _d === void 0 ? void 0 : _d.payment), {
                effectiveDate: null
              })), {
                paymentType: payy_1.paymentType
              })
            });
          }).finally(function () {
            setTimeout(function () {
              _this.setState({
                isLoading: false
              });
            }, 1000);
          });
          refreshSingleLoanData(layout.selectedLoanNumber, payment_1);
          _this.props.authenticate();
          setTimeout(function () {
            _this.setState({
              isLoading: false
            });
            _this.props.navigation.navigate("Payment/Pending");
          }, 500);
        } else {
          fetch("".concat(layout.pennyHomeUrl, "api/payment/").concat(!isOtp ? edit ? "update_ach" : "post_ach" : edit ? "update_payment" : "post_payment"), {
            method: 'POST',
            headers: {
              "Content-Type": "application/json; charset=utf-8",
              "Authorization": "Bearer ".concat(_this.props.layout.token),
              "TrackerSessionId": "".concat(_this.props.layout.trackerSession)
            },
            body: JSON.stringify(__assign(__assign({}, payment_1), {
              bankAccount: __assign(__assign({}, payment_1.bankAccount), {
                unmaskedAccountNumber: undefined,
                unmaskedAccountNumberEncode: encryptBankAccountNumber(payment_1.bankAccount.unmaskedAccountNumber),
                confirmAccountNumber: undefined,
                confirmAccountNumberEncode: encryptBankAccountNumber(payment_1.bankAccount.confirmAccountNumber)
              })
            }))
          }).then(function (res) {
            return res.json();
          }).then(function (data) {
            var _a, _b, _c;
            if (data && (((_a = Object.keys(data === null || data === void 0 ? void 0 : data.errors)) === null || _a === void 0 ? void 0 : _a.length) == 0 || !(data === null || data === void 0 ? void 0 : data.errors))) {
              payment_1.status = 0;
              payment_1.canCancel = false;
              payment_1.canEdit = false;
              _this.setState({
                displayedConfirmationId: (data === null || data === void 0 ? void 0 : data.displayedConfirmationId) || "6101",
                open: true,
                paymentSubmitted: false,
                modalType: !isOtp ? "achPaymentSubmitted" : "paymentSubmitted",
                page: isOtp ? "pay" : "confirm"
              }, function () {
                var _a, _b, _c, _d;
                if (holdViewOpen) {
                  holdViewOpen();
                }
                var payy = (_b = (_a = layout.paymentModel) === null || _a === void 0 ? void 0 : _a.pendingPayments) === null || _b === void 0 ? void 0 : _b.find(function (s) {
                  return s.paymentType == 201309;
                });
                var newPaymentModel = __assign({}, layout.paymentModel);
                var p = (_d = (_c = layout.paymentModel) === null || _c === void 0 ? void 0 : _c.pendingPayments) === null || _d === void 0 ? void 0 : _d.findIndex(function (s) {
                  return (s === null || s === void 0 ? void 0 : s.achConfigurationKey) == (payy === null || payy === void 0 ? void 0 : payy.achConfigurationKey);
                });
                newPaymentModel.pendingPayments.splice(p, 1);
                _this.props.dispatch({
                  type: PAYMENT_VALIDATION,
                  payment: newPaymentModel
                }, function () {
                  return _this.props.refreshBankData(layout.selectedLoanNumber);
                });
                refreshSingleLoanData(layout.selectedLoanNumber, payment_1);
              });
              _this.props.authenticate();
              _this.setState({
                submitModalOpen: true
              });
            } else {
              var errorType = data === null || data === void 0 ? void 0 : data.errors;
              if ((_b = data === null || data === void 0 ? void 0 : data.errors) === null || _b === void 0 ? void 0 : _b.time) {
                if (((_c = data === null || data === void 0 ? void 0 : data.errors) === null || _c === void 0 ? void 0 : _c.time) === 'AfterWorkingHoursPaymentErrorMessage') {
                  errorType = {
                    time: _this.props.translations.AfterWorkingHoursPaymentErrorMessage
                  };
                }
                _this.setState(_this.intiialState(_this.props));
                _this.props.dispatch({
                  type: PAYMENT_VALIDATION,
                  payment: {}
                });
                _this.props.authenticate();
              }
              _this.setState({
                paymentSubmitted: false,
                errors: errorType,
                isLoading: false
              });
            }
          }).finally(function () {
            setTimeout(function () {
              _this.setState({
                isLoading: false
              });
            }, 2000);
          });
        }
      } else {
        _this.props.authenticate();
      }
    };
    _this.getEffectiveDate = function () {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
      var layout = _this.props.layout;
      var _p = _this.state,
        graceDays = _p.graceDays,
        originalNextPaymentDueDate = _p.originalNextPaymentDueDate;
      var checkDate = function (amount) {
        var dtc = moment(layout.localTime);
        var retv = 4;
        for (var i = 1; i <= amount; i++) {
          var d = dtc.add('days', 1);
          if (d.day() == 0) {
            retv = 5;
          }
        }
        return retv;
      };
      var achStart = moment(originalNextPaymentDueDate).set('month', moment(layout.localTime).month()).set('year', moment(layout.localTime).year());
      var draftDate = [{
        key: -1,
        label: "".concat(achStart.clone().date()),
        value: achStart.clone().date(),
        date: achStart.clone().format("MM/DD/YYYY")
      }];
      var days = graceDays + 1;
      for (var i = 1; i < days; i++) {
        if (achStart.clone().add("day", i).isSameOrAfter(moment(layout.localTime).endOf('month'))) {
          break;
        }
        draftDate.push({
          key: i,
          label: "".concat(achStart.clone().add("day", i).date()),
          value: achStart.clone().add("day", i).date(),
          date: achStart.clone().add("day", i).format("MM/DD/YYYY")
        });
      }
      var month = moment(originalNextPaymentDueDate) > moment(layout.localTime) ? moment(originalNextPaymentDueDate).month() : moment(layout.localTime).month();
      var ckDate = draftDate[((_g = (_d = (_b = (_a = _this.props.route.params) === null || _a === void 0 ? void 0 : _a.AutoPayDate) !== null && _b !== void 0 ? _b : moment((_c = _this.state) === null || _c === void 0 ? void 0 : _c.effectiveDate).date()) !== null && _d !== void 0 ? _d : moment((_f = (_e = _this.state) === null || _e === void 0 ? void 0 : _e.payment) === null || _f === void 0 ? void 0 : _f.effectiveDate).date()) !== null && _g !== void 0 ? _g : 1) - 1];
      var current = moment(layout.localTime);
      if (moment(layout.localTime).add('days', checkDate(4)).isAfter(moment(ckDate === null || ckDate === void 0 ? void 0 : ckDate.date, "MM/DD/YYYY")) && moment(originalNextPaymentDueDate).isSameOrBefore(moment(layout.localTime).add('day', checkDate(4)))) {
        var check = function () {
          var currentst = moment(layout.localTime).add('days', checkDate(4));
          var st = currentst.month();
          var ct = moment(layout.localTime).month();
          if (st > ct) {
            return currentst.date();
          }
          return 0;
        };
        if (moment(layout.localTime).date() > current.endOf('month').date() - checkDate(4) && parseInt((_j = (_h = _this.props.route.params) === null || _h === void 0 ? void 0 : _h.AutoPayDate) !== null && _j !== void 0 ? _j : moment((_k = _this.state) === null || _k === void 0 ? void 0 : _k.effectiveDate).date()) <= check()) {
          month = current.add('month', 2).month();
        } else {
          month = current.add('month', 1).month();
        }
      }
      var draftdate = moment(originalNextPaymentDueDate).set('date', parseInt((_m = (_l = _this.props.route.params) === null || _l === void 0 ? void 0 : _l.AutoPayDate) !== null && _m !== void 0 ? _m : moment((_o = _this.state) === null || _o === void 0 ? void 0 : _o.effectiveDate).date()));
      var finaldate = draftdate === null || draftdate === void 0 ? void 0 : draftdate.set('month', month);
      if (finaldate < moment(layout.localTime)) {
        finaldate.set('year', finaldate.year() + 1);
      }
      _this.setState({
        draftDate: true,
        effectiveDate: finaldate,
        payment: __assign(__assign({}, _this.state.payment), {
          effectiveDate: finaldate
        })
      });
    };
    _this.state = {
      pendingPayments: [],
      paymentType: 201299,
      graceDays: (_a = props.layout.currentLoan) === null || _a === void 0 ? void 0 : _a.graceDays,
      effectiveDate: '',
      expRef: /*#__PURE__*/React.createRef(),
      canUseDebitCard: true,
      open: false,
      edit: false,
      holdView: false,
      modalOpen: false,
      submitModalOpen: false,
      cancelModalOpen: false,
      originalNextPaymentDueDate: (_b = props.layout.currentLoan) === null || _b === void 0 ? void 0 : _b.originalNextPaymentDueDate,
      autopayEnabled: false,
      cancelAutopay: true,
      isLoading: false,
      showSelectPaymentMethod: false,
      isPaymentMethodUpdated: false,
      payment: {
        "delinquentPayments": [],
        "mobile": props.layout.mobile || false,
        "loanId": 0,
        "errors": {},
        "isCancelable": false,
        "errorToDisplayToUser": null,
        "suspenseCode": null,
        "bankAccount": {
          "bankAccountType": 201287
        },
        "suspenseAmount": "0.00",
        "paymentId": 0,
        "monthlyPaymentAmount": "0.00",
        "doubleMonthlyPaymentAmount": 0,
        "numberOfPayments": 1,
        "originalEffectiveDate": null,
        "isEditable": false,
        "feesDues": [{
          "feeAmtField": "0.00",
          "feeCodeField": "1",
          "sequenceNumberField": "0.00",
          "fieldName": "lateFeesDue"
        }, {
          "feeAmtField": "0.00",
          "feeCodeField": "2",
          "sequenceNumberField": 0,
          "fieldName": "nsfFeesDue"
        }, {
          "feeAmtField": "0.00",
          "feeCodeField": "G",
          "sequenceNumberField": 0,
          "fieldName": "debitCardConvenienceFee"
        }, {
          "feeAmtField": "0.00",
          "feeCodeField": "1",
          "sequenceNumberField": 0,
          "fieldName": "otherFeesDue"
        }],
        "totalFeesAmount": "0.00",
        "additionalEscrowAmount": "0.00",
        "requestedByUserName": null,
        "paymentType": null,
        "source": 0,
        "paymentUrl": null,
        "forbearanceAmount": "0.00",
        "userAgent": null,
        "delinquentPaymentAmount": "0.00",
        "delinquentPaymentDueDate": null,
        "nextDelinquentPaymentDate": "0001-01-01T00:00:00",
        "currentPrincipalBalance": 0.0,
        "logId": null,
        "otdRequestQueue": null,
        "isFromCashQueue": false,
        "loanSummary": {},
        "draftSource": 0,
        "isPostedToLoanservices": false,
        "dueDate": null,
        "mspDueDate": null,
        "effectiveDate": null,
        "achRegisterationConfirmationId": 0,
        "totalDraftAmount": "0.00",
        "additionalPrincipalAmount": "0.00",
        "status": 0,
        "bankRoutingTransitNumber": null,
        "bankAccountNumber": null,
        "bankAccountType": 201287,
        "bankAccountName": null,
        "hasPaymentChange": false,
        "created": moment(props.layout.localTime),
        "createdBy": null,
        "modified": moment(props.layout.localTime),
        "modifiedBy": null,
        "achConfigurationKey": null,
        "paymentMethod": 0,
        "fiservConfirmationNumber": null
      }
    };
    return _this;
  }
  SetupAutoPay.getDerivedStateFromProps = function (props, state) {
    var _this = this;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79, _80, _81, _82, _83, _84, _85, _86, _87, _88, _89, _90, _91, _92, _93, _94, _95, _96, _97, _98, _99, _100, _101, _102, _103, _104, _105, _106;
    var route = props.route;
    var path = props.layout.mobile ? route.pathname : window.location.pathname;
    var achExist = (_c = (_b = (_a = props.layout) === null || _a === void 0 ? void 0 : _a.paymentModel) === null || _b === void 0 ? void 0 : _b.pendingPayments) === null || _c === void 0 ? void 0 : _c.find(function (s) {
      return s.paymentType == 201309;
    });
    if (((_d = state.payment) === null || _d === void 0 ? void 0 : _d.monthlyPaymentAmount) == "0.00" && props.layout.currentLoan != null && props.layout.paymentModel != null && (!state.isMounted || !state.isMountedBank) || path != state.pathname) {
      var modifications = props.layout.modifications;
      var StatusTypeId = modifications === null || modifications === void 0 ? void 0 : modifications.statusTypeId;
      var IsForebearanceOTPVisible = modifications === null || modifications === void 0 ? void 0 : modifications.isForebearanceOTPVisible;
      var isTrialPaymentVisible_1 = modifications === null || modifications === void 0 ? void 0 : modifications.isTrialPaymentVisible;
      var forbearacne_1 = StatusTypeId > 0 && IsForebearanceOTPVisible || ((_e = props.layout.currentLoan) === null || _e === void 0 ? void 0 : _e.isLoanInForbearance) || ((_j = (_h = (_g = (_f = props.layout) === null || _f === void 0 ? void 0 : _f.paymentModel) === null || _g === void 0 ? void 0 : _g.loan) === null || _h === void 0 ? void 0 : _h.defaultPayments) === null || _j === void 0 ? void 0 : _j.route) == "Default" && (((_o = (_m = (_l = (_k = props.layout) === null || _k === void 0 ? void 0 : _k.paymentModel) === null || _l === void 0 ? void 0 : _l.loan) === null || _m === void 0 ? void 0 : _m.defaultPayments) === null || _o === void 0 ? void 0 : _o.ruleId) == RuleId.Increased_Payment_Plan || ((_s = (_r = (_q = (_p = props.layout) === null || _p === void 0 ? void 0 : _p.paymentModel) === null || _q === void 0 ? void 0 : _q.loan) === null || _r === void 0 ? void 0 : _r.defaultPayments) === null || _s === void 0 ? void 0 : _s.ruleId) == RuleId.Reduced_Payment_Plan);
      var edit = achExist;
      if ((_t = props.route) === null || _t === void 0 ? void 0 : _t.params) {
        edit = (_v = (_u = props.route) === null || _u === void 0 ? void 0 : _u.params) === null || _v === void 0 ? void 0 : _v.edit;
      }
      var show = props.layout.mobile ? props.isOtp && !edit && (((_x = (_w = props.layout.paymentModel) === null || _w === void 0 ? void 0 : _w.pendingPayments) === null || _x === void 0 ? void 0 : _x.filter(function (s) {
        return s.paymentType == 201298 || s.paymentType == 201309;
      }).length) > 0 || moment((_y = props.layout.currentLoan) === null || _y === void 0 ? void 0 : _y.nextPaymentDueDate).date() >= moment(props.layout.localTime).date() && !((_0 = (_z = props.layout) === null || _z === void 0 ? void 0 : _z.modifications) === null || _0 === void 0 ? void 0 : _0.isTrialPaymentVisible) && !forbearacne_1 && !((_2 = (_1 = props.layout) === null || _1 === void 0 ? void 0 : _1.paymentModel) === null || _2 === void 0 ? void 0 : _2.mustMakeDelinquentPayment) && !state.isMounted) && state.isMountedBank !== undefined : props.isOtp && !edit && (((_4 = (_3 = props.layout.paymentModel) === null || _3 === void 0 ? void 0 : _3.pendingPayments) === null || _4 === void 0 ? void 0 : _4.filter(function (s) {
        return s.paymentType == 201298 || s.paymentType == 201309;
      }).length) > 0 || moment((_5 = props.layout.currentLoan) === null || _5 === void 0 ? void 0 : _5.nextPaymentDueDate).date() >= moment(props.layout.localTime).date() && !((_7 = (_6 = props.layout) === null || _6 === void 0 ? void 0 : _6.modifications) === null || _7 === void 0 ? void 0 : _7.isTrialPaymentVisible) && !forbearacne_1 && !((_9 = (_8 = props.layout) === null || _8 === void 0 ? void 0 : _8.paymentModel) === null || _9 === void 0 ? void 0 : _9.mustMakeDelinquentPayment) && !state.isMounted);
      var status_1 = (_10 = props.layout.selectedLoanAvailability) === null || _10 === void 0 ? void 0 : _10.status;
      var currentTime = moment(props.layout.localTime);
      var dueDate = moment(props.layout.currentLoan.nextPaymentDueDate);
      var paymentWindow_1 = !edit && (ammountPaymentAhead(status_1, 2) || (getActiveFeatures(props.layout.features, "BRMS_Delinquent", props.layout.whitelisted) ? false : ((_12 = (_11 = props.layout) === null || _11 === void 0 ? void 0 : _11.paymentModel) === null || _12 === void 0 ? void 0 : _12.numberofPendingPayments) >= 2) || moment((_13 = props.layout.currentLoan) === null || _13 === void 0 ? void 0 : _13.originalNextPaymentDueDate).isAfter(moment(props.layout.localTime)) && moment([dueDate.year(), dueDate.month(), dueDate.date()]).diff(moment([currentTime.year(), currentTime.month(), dueDate.date()]), 'months', true) > 2);
      Object.keys(((_15 = (_14 = props.layout) === null || _14 === void 0 ? void 0 : _14.paymentModel) === null || _15 === void 0 ? void 0 : _15.payment) || {}).map(function (s) {
        if ("suspenseAmount,monthlyPaymentAmount,totalFeesAmount,additionalEscrowAmount,delinquentPaymentAmount,additionalPrincipalAmount".indexOf(s) > -1) {
          props.layout.paymentModel.payment[s] = isNaN(props.layout.paymentModel.payment[s]) ? 0.00 : parseFloat(props.layout.paymentModel.payment[s]).toFixed(2);
        }
      });
      if (((_16 = props.layout.paymentModel) === null || _16 === void 0 ? void 0 : _16.payment) && ((_18 = (_17 = props.layout.paymentModel) === null || _17 === void 0 ? void 0 : _17.payment) === null || _18 === void 0 ? void 0 : _18.feesDues.length) > 0) {
        props.layout.paymentModel.payment.feesDues.forEach(function (s) {
          s.feeAmtField = isNaN(s.feeAmtField) ? 0.00 : parseFloat(s.feeAmtField).toFixed(2);
        });
      }
      if (!edit && ((_22 = (_21 = (_20 = (_19 = props.layout) === null || _19 === void 0 ? void 0 : _19.paymentModel) === null || _20 === void 0 ? void 0 : _20.payment) === null || _21 === void 0 ? void 0 : _21.feesDues) === null || _22 === void 0 ? void 0 : _22.length) > 0) {
        var oFee = props.layout.paymentModel.payment.feesDues.find(function (w) {
          return w.fieldName == "otherFeesDue";
        });
        var oFeeIndex = props.layout.paymentModel.payment.feesDues.findIndex(function (w) {
          return w.fieldName == "otherFeesDue";
        });
        if (oFee) {
          oFee.feeAmtField = "0.00";
          props.layout.paymentModel.payment.feesDues.splice(oFeeIndex, 1, oFee);
        }
      }
      var replaceDollarSign_1 = function (value) {
        var _a;
        return (_a = value === null || value === void 0 ? void 0 : value.toString()) === null || _a === void 0 ? void 0 : _a.replace("$", "").replace(",", "");
      };
      var totalFees_1 = function () {
        var _a, _b;
        var bankAccountType = state.payment.bankAccount.bankAccountType;
        return (_b = (_a = state.payment.feesDues) === null || _a === void 0 ? void 0 : _a.reduce(function (accumulator, currentValue) {
          if (state.payment.paymentType != 201298 && state.payment.paymentType != 201299 && state.payment.paymentType != 201311 && parseInt(bankAccountType) != 201288) {
            return accumulator;
          }
          if (currentValue.fieldName == "debitCardConvenienceFee" && parseInt(bankAccountType) != 201288) {
            return accumulator;
          }
          return accumulator + parseFloat(replaceDollarSign_1(currentValue.feeAmtField));
        }, 0)) !== null && _b !== void 0 ? _b : 0;
      };
      var minimumPaymentDue = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        var minimuPaymentDue = (_a = state.payment) === null || _a === void 0 ? void 0 : _a.monthlyPaymentAmount;
        if (((_e = (_d = (_c = (_b = props.layout) === null || _b === void 0 ? void 0 : _b.paymentModel) === null || _c === void 0 ? void 0 : _c.loan) === null || _d === void 0 ? void 0 : _d.defaultPayments) === null || _e === void 0 ? void 0 : _e.route) == "Default" && (((_j = (_h = (_g = (_f = props.layout) === null || _f === void 0 ? void 0 : _f.paymentModel) === null || _g === void 0 ? void 0 : _g.loan) === null || _h === void 0 ? void 0 : _h.defaultPayments) === null || _j === void 0 ? void 0 : _j.ruleId) == RuleId.Increased_Payment_Plan || ((_o = (_m = (_l = (_k = props.layout) === null || _k === void 0 ? void 0 : _k.paymentModel) === null || _l === void 0 ? void 0 : _l.loan) === null || _m === void 0 ? void 0 : _m.defaultPayments) === null || _o === void 0 ? void 0 : _o.ruleId) == RuleId.Reduced_Payment_Plan)) {
          (_t = (_s = (_r = (_q = (_p = props.layout) === null || _p === void 0 ? void 0 : _p.paymentModel) === null || _q === void 0 ? void 0 : _q.loan) === null || _r === void 0 ? void 0 : _r.defaultPayments) === null || _s === void 0 ? void 0 : _s.defaultPaymentsDue) === null || _t === void 0 ? void 0 : _t.forEach(function (defpayment) {
            var _a;
            if (((_a = defpayment === null || defpayment === void 0 ? void 0 : defpayment.paymentType) === null || _a === void 0 ? void 0 : _a.toLowerCase()) == "r" && (defpayment.defaultPaymentType == defaulPaymentType.PIT || defpayment.defaultPaymentType == defaulPaymentTypeStr.PIT)) {
              minimuPaymentDue = defpayment.paymentAmountDue;
            }
          });
        }
        return minimuPaymentDue;
      };
      var paymentType = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        if (!props.isOtp) {
          return 201309;
        } else {
          if (((_c = (_b = (_a = props.layout.paymentModel) === null || _a === void 0 ? void 0 : _a.payment) === null || _b === void 0 ? void 0 : _b.delinquentPayments) === null || _c === void 0 ? void 0 : _c.length) > 1) {
            if ((_f = (_e = (_d = props.layout.paymentModel) === null || _d === void 0 ? void 0 : _d.payment) === null || _e === void 0 ? void 0 : _e.delinquentPayments) === null || _f === void 0 ? void 0 : _f.some(function (s) {
              return !s.paid;
            })) {
              return 201311;
            } else {
              return 201299;
            }
          }
          if (isTrialPaymentVisible_1) {
            return 201296;
          } else {
            if (paymentWindow_1) {
              if (!(((_h = (_g = props.layout) === null || _g === void 0 ? void 0 : _g.currentLoan) === null || _h === void 0 ? void 0 : _h.escrowFlag) || totalFees_1() > 0)) {
                return 201297;
              } else {
                return 201299;
              }
            } else {
              if (forbearacne_1) {
                var payRuleId = (_m = (_l = (_k = (_j = props.layout) === null || _j === void 0 ? void 0 : _j.paymentModel) === null || _k === void 0 ? void 0 : _k.loan) === null || _l === void 0 ? void 0 : _l.defaultPayments) === null || _m === void 0 ? void 0 : _m.ruleId;
                if (payRuleId == RuleId.Reduced_Payment_Plan || payRuleId == RuleId.Increased_Payment_Plan) {
                  return 1000146;
                } else {
                  return 1000145;
                }
              } else {
                return (_p = (_o = props.layout.paymentModel) === null || _o === void 0 ? void 0 : _o.payment) === null || _p === void 0 ? void 0 : _p.paymentType;
              }
            }
          }
        }
      };
      var achnext = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (props.isOtp) {
          return moment((_b = (_a = props.layout.paymentModel) === null || _a === void 0 ? void 0 : _a.payment) === null || _b === void 0 ? void 0 : _b.effectiveDate);
        } else {
          var effectiveDateValue = moment((_c = props.layout.currentLoan) === null || _c === void 0 ? void 0 : _c.originalNextPaymentDueDate).set('date', parseInt((_h = (_f = (_e = (_d = props.route) === null || _d === void 0 ? void 0 : _d.params) === null || _e === void 0 ? void 0 : _e.AutoPayDate) !== null && _f !== void 0 ? _f : moment((_g = _this.state) === null || _g === void 0 ? void 0 : _g.effectiveDate).date()) !== null && _h !== void 0 ? _h : 1));
          return moment(effectiveDateValue).date() > 16 ? moment((_j = props.layout.currentLoan) === null || _j === void 0 ? void 0 : _j.originalNextPaymentDueDate).set('date', 1) : effectiveDateValue;
        }
      };
      var editPayment = props.layout.mobile ? __assign(__assign(__assign({}, (_24 = (_23 = props.route) === null || _23 === void 0 ? void 0 : _23.params) === null || _24 === void 0 ? void 0 : _24.payment), {
        feesHelperMethod: (_27 = (_26 = (_25 = props.layout) === null || _25 === void 0 ? void 0 : _25.paymentModel) === null || _26 === void 0 ? void 0 : _26.payment) === null || _27 === void 0 ? void 0 : _27.feesHelperMethod
      }), achExist) : __assign(__assign({}, (_29 = (_28 = props.location) === null || _28 === void 0 ? void 0 : _28.state) === null || _29 === void 0 ? void 0 : _29.payment), {
        feesHelperMethod: props.layout.paymentModel.payment.feesHelperMethod
      });
      var incomingPayment = edit ? editPayment : !props.isOtp && achExist ? achExist : __assign(__assign(__assign({}, state.payment), props.layout.paymentModel.payment), {
        bankAccount: __assign(__assign({}, (_31 = (_30 = props.layout.paymentModel) === null || _30 === void 0 ? void 0 : _30.payment) === null || _31 === void 0 ? void 0 : _31.bankAccount), {
          bankAccountType: ((_34 = (_33 = (_32 = props.layout.paymentModel) === null || _32 === void 0 ? void 0 : _32.payment) === null || _33 === void 0 ? void 0 : _33.bankAccount) === null || _34 === void 0 ? void 0 : _34.bankAccountType) != 201288 ? (_37 = (_36 = (_35 = props.layout.paymentModel) === null || _35 === void 0 ? void 0 : _35.payment) === null || _36 === void 0 ? void 0 : _36.bankAccount) === null || _37 === void 0 ? void 0 : _37.bankAccountType : 201286
        }),
        bankAccountType: ((_40 = (_39 = (_38 = props.layout.paymentModel) === null || _38 === void 0 ? void 0 : _38.payment) === null || _39 === void 0 ? void 0 : _39.bankAccount) === null || _40 === void 0 ? void 0 : _40.bankAccountType) && ((_43 = (_42 = (_41 = props.layout.paymentModel) === null || _41 === void 0 ? void 0 : _41.payment) === null || _42 === void 0 ? void 0 : _42.bankAccount) === null || _43 === void 0 ? void 0 : _43.bankAccountType) != 201288 ? (_46 = (_45 = (_44 = props.layout.paymentModel) === null || _44 === void 0 ? void 0 : _44.payment) === null || _45 === void 0 ? void 0 : _45.bankAccount) === null || _46 === void 0 ? void 0 : _46.bankAccountType : 201286,
        paymentType: paymentType(),
        totalDraftAmount: paymentWindow_1 ? 0 : (_48 = (_47 = props.layout.paymentModel) === null || _47 === void 0 ? void 0 : _47.payment) === null || _48 === void 0 ? void 0 : _48.totalDraftAmount,
        dueDate: (_49 = props.layout.currentLoan) === null || _49 === void 0 ? void 0 : _49.nextPaymentDueDate,
        effectiveDate: achnext(),
        additionalPrincipalAmount: (_55 = (_51 = (_50 = props.route.params) === null || _50 === void 0 ? void 0 : _50.additionalPrincipalAmount) !== null && _51 !== void 0 ? _51 : (_54 = (_53 = (_52 = props.layout.paymentModel) === null || _52 === void 0 ? void 0 : _52.pendingPayments) === null || _53 === void 0 ? void 0 : _53.find(function (s) {
          return s.paymentType == 201309;
        })) === null || _54 === void 0 ? void 0 : _54.additionalPrincipalAmount) !== null && _55 !== void 0 ? _55 : 0,
        forbearanceAmount: minimumPaymentDue()
      });
      if (!edit && ((_56 = incomingPayment === null || incomingPayment === void 0 ? void 0 : incomingPayment.delinquentPayments) === null || _56 === void 0 ? void 0 : _56.length) > 1) {
        var lastUnselectedIndex = null;
        incomingPayment.delinquentPayments.sort(function (a, b) {
          return new Date(a.dueDate) - new Date(b.dueDate);
        });
        for (var i = 0; i < incomingPayment.delinquentPayments.length; i++) {
          if (!incomingPayment.delinquentPayments[i].selected && ((_58 = (_57 = incomingPayment.delinquentPayments) === null || _57 === void 0 ? void 0 : _57[i - 1]) === null || _58 === void 0 ? void 0 : _58.status) == 'Pending') {
            lastUnselectedIndex = i;
            break;
          }
        }
        if ((incomingPayment === null || incomingPayment === void 0 ? void 0 : incomingPayment.delinquentPayments) !== null && lastUnselectedIndex > 0 && lastUnselectedIndex < ((_59 = incomingPayment.delinquentPayments) === null || _59 === void 0 ? void 0 : _59.length)) {
          incomingPayment.delinquentPayments[lastUnselectedIndex].selected = true;
        }
      }
      var setPayment = __assign(__assign({}, props.layout), {
        paymentModel: __assign(__assign({}, props.layout.paymentModel), {
          payment: __assign(__assign({}, incomingPayment), {
            additionalPrincipalAmount: (_61 = (_60 = props.route.params) === null || _60 === void 0 ? void 0 : _60.additionalPrincipalAmount) !== null && _61 !== void 0 ? _61 : (_64 = (_63 = (_62 = props.layout.paymentModel) === null || _62 === void 0 ? void 0 : _62.pendingPayments) === null || _63 === void 0 ? void 0 : _63.find(function (s) {
              return s.paymentType == 201309;
            })) === null || _64 === void 0 ? void 0 : _64.additionalPrincipalAmount
          })
        })
      });
      if (props.testFixture) {
        props.testFixture(setPayment);
      }
      var getLatestPaidDueDate = function (payments) {
        var _a;
        var latestDueDate = (payments === null || payments === void 0 ? void 0 : payments.length) > 0 ? (_a = payments[0]) === null || _a === void 0 ? void 0 : _a.dueDate : null;
        for (var _i = 0, payments_1 = payments; _i < payments_1.length; _i++) {
          var payment = payments_1[_i];
          if (payment.paid && (!latestDueDate || payment.dueDate > latestDueDate)) {
            latestDueDate = payment.dueDate;
          }
        }
        return moment(latestDueDate).add('month', 1);
      };
      return __assign(__assign({}, state), {
        open: show,
        pathname: path,
        modalType: "pendingPayments",
        lateChargeGraceEndDate: (_65 = props.layout.currentLoan) === null || _65 === void 0 ? void 0 : _65.lateChargeGraceEndDate,
        graceDays: (_66 = props.layout.currentLoan) === null || _66 === void 0 ? void 0 : _66.graceDays,
        effectiveDate: (_70 = (_69 = (_68 = (_67 = props.layout.paymentModel) === null || _67 === void 0 ? void 0 : _67.pendingPayments) === null || _68 === void 0 ? void 0 : _68.find(function (s) {
          return s.paymentType == 201309;
        })) === null || _69 === void 0 ? void 0 : _69.effectiveDate) !== null && _70 !== void 0 ? _70 : achnext(),
        pendingPaymentDate: ((_72 = (_71 = props.layout.paymentModel) === null || _71 === void 0 ? void 0 : _71.pendingPayments) === null || _72 === void 0 ? void 0 : _72.find(function (s) {
          return s.paymentType == 201298 || s.paymentType == 201311;
        })) ? (_75 = (_74 = (_73 = props.layout.paymentModel) === null || _73 === void 0 ? void 0 : _73.pendingPayments) === null || _74 === void 0 ? void 0 : _74.filter(function (s) {
          return s.paymentType == 201298 || s.paymentType == 201311;
        })) === null || _75 === void 0 ? void 0 : _75.sort(function (a, b) {
          return new Date(a.dueDate) - new Date(b.dueDate);
        })[0] : {},
        lastEffectiveDate: ((_77 = (_76 = props.layout.paymentModel) === null || _76 === void 0 ? void 0 : _76.pendingPayments) === null || _77 === void 0 ? void 0 : _77.find(function (s) {
          return s.paymentType == 201298 || s.paymentType == 201311;
        })) ? (_80 = (_79 = (_78 = props.layout.paymentModel) === null || _78 === void 0 ? void 0 : _78.pendingPayments) === null || _79 === void 0 ? void 0 : _79.filter(function (s) {
          return s.paymentType == 201298 || s.paymentType == 201311;
        })) === null || _80 === void 0 ? void 0 : _80.sort(function (a, b) {
          return new Date(b.effectiveDate) - new Date(a.effectiveDate);
        })[0] : {},
        isMounted: ((_82 = (_81 = props.layout.paymentModel) === null || _81 === void 0 ? void 0 : _81.payment) === null || _82 === void 0 ? void 0 : _82.monthlyPaymentAmount) != undefined,
        isMountedBank: true,
        edit: edit || false,
        originalNextPaymentDueDate: (_83 = props.layout.currentLoan) === null || _83 === void 0 ? void 0 : _83.originalNextPaymentDueDate,
        nextPaymentDueDate: ((_84 = incomingPayment === null || incomingPayment === void 0 ? void 0 : incomingPayment.delinquentPayments) === null || _84 === void 0 ? void 0 : _84.length) > 0 ? getLatestPaidDueDate(incomingPayment.delinquentPayments) : (_85 = props.layout.currentLoan) === null || _85 === void 0 ? void 0 : _85.nextPaymentDueDate,
        canMakePrincipleReduction: ((_87 = (_86 = props.layout) === null || _86 === void 0 ? void 0 : _86.currentLoan) === null || _87 === void 0 ? void 0 : _87.delinquentPaymentCount) <= 0,
        page: !props.isOtp && achExist != undefined && !edit ? "confirm" : state.page == "bank" ? "bank" : "pay",
        achExist: achExist != undefined && !props.isOtp,
        openedTerms: achExist != undefined && !props.isOtp || edit || false,
        payment: incomingPayment,
        edit: props.layout.mobile ? achExist : (_89 = (_88 = props.location) === null || _88 === void 0 ? void 0 : _88.state) === null || _89 === void 0 ? void 0 : _89.edit,
        autopayEnabled: achExist
      });
    } else if (achExist) {
      var editPayment = props.layout.mobile ? __assign(__assign(__assign({}, (_91 = (_90 = props.route) === null || _90 === void 0 ? void 0 : _90.params) === null || _91 === void 0 ? void 0 : _91.payment), {
        feesHelperMethod: (_94 = (_93 = (_92 = props.layout) === null || _92 === void 0 ? void 0 : _92.paymentModel) === null || _93 === void 0 ? void 0 : _93.payment) === null || _94 === void 0 ? void 0 : _94.feesHelperMethod
      }), achExist) : __assign(__assign({}, (_96 = (_95 = props.location) === null || _95 === void 0 ? void 0 : _95.state) === null || _96 === void 0 ? void 0 : _96.payment), {
        feesHelperMethod: props.layout.paymentModel.payment.feesHelperMethod
      });
      return __assign(__assign({}, state), {
        achExist: achExist != undefined && !props.isOtp,
        payment: __assign(__assign({}, editPayment), {
          additionalPrincipalAmount: state.payment.additionalPrincipalAmount,
          effectiveDate: state.payment.effectiveDate
        }),
        edit: props.layout.mobile ? achExist && Object.keys(achExist).length > 0 : (_98 = (_97 = props.location) === null || _97 === void 0 ? void 0 : _97.state) === null || _98 === void 0 ? void 0 : _98.edit,
        originalNextPaymentDueDate: (_99 = props.layout.currentLoan) === null || _99 === void 0 ? void 0 : _99.originalNextPaymentDueDate,
        autopayEnabled: props.layout.mobile ? achExist && Object.keys(achExist).length > 0 : (_101 = (_100 = props.location) === null || _100 === void 0 ? void 0 : _100.state) === null || _101 === void 0 ? void 0 : _101.autopayEnabled
      });
    }
    return __assign(__assign({}, state), {
      achExist: achExist != undefined && !props.isOtp,
      edit: props.layout.mobile ? achExist && Object.keys(achExist).length > 0 : (_103 = (_102 = props.location) === null || _102 === void 0 ? void 0 : _102.state) === null || _103 === void 0 ? void 0 : _103.edit,
      originalNextPaymentDueDate: (_104 = props.layout.currentLoan) === null || _104 === void 0 ? void 0 : _104.originalNextPaymentDueDate,
      autopayEnabled: props.layout.mobile ? achExist && Object.keys(achExist).length > 0 : (_106 = (_105 = props.location) === null || _105 === void 0 ? void 0 : _105.state) === null || _106 === void 0 ? void 0 : _106.autopayEnabled
    });
  };
  SetupAutoPay.prototype.render = function () {
    var _this = this;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    var _r = this.props,
      translations = _r.translations,
      layout = _r.layout,
      route = _r.route;
    var _s = this.state,
      edit = _s.edit,
      autopayEnabled = _s.autopayEnabled,
      isLoading = _s.isLoading,
      originalNextPaymentDueDate = _s.originalNextPaymentDueDate;
    var paymentModel = layout.paymentModel,
      currentLoan = layout.currentLoan;
    var isOtp = this.props.isOtp;
    if ((_a = route === null || route === void 0 ? void 0 : route.params) === null || _a === void 0 ? void 0 : _a.isOtp) {
      isOtp = true;
    }
    var autoPayDescriptionContent = [{
      title: translations.BankRoutingTransitNumber,
      value: (_c = (_b = paymentModel === null || paymentModel === void 0 ? void 0 : paymentModel.payment) === null || _b === void 0 ? void 0 : _b.bankAccount) === null || _c === void 0 ? void 0 : _c.routingTransitNumber
    }, {
      title: translations.BankAccount,
      value: (_e = (_d = paymentModel === null || paymentModel === void 0 ? void 0 : paymentModel.payment) === null || _d === void 0 ? void 0 : _d.bankAccount) === null || _e === void 0 ? void 0 : _e.accountNumber
    }, {
      title: translations.BankAccountType,
      value: ((_g = (_f = paymentModel === null || paymentModel === void 0 ? void 0 : paymentModel.payment) === null || _f === void 0 ? void 0 : _f.bankAccount) === null || _g === void 0 ? void 0 : _g.bankAccountType) === 201286 ? translations.Checking : ((_j = (_h = paymentModel === null || paymentModel === void 0 ? void 0 : paymentModel.payment) === null || _h === void 0 ? void 0 : _h.bankAccount) === null || _j === void 0 ? void 0 : _j.bankAccountType) === 201287 ? translations.Savings : ((_l = (_k = paymentModel === null || paymentModel === void 0 ? void 0 : paymentModel.payment) === null || _k === void 0 ? void 0 : _k.bankAccount) === null || _l === void 0 ? void 0 : _l.bankAccountType) === 201288 ? "Debit Card" : "Unknown"
    }, {
      title: translations.NameOnBankAccount,
      value: (_o = (_m = paymentModel === null || paymentModel === void 0 ? void 0 : paymentModel.payment) === null || _m === void 0 ? void 0 : _m.bankAccount) === null || _o === void 0 ? void 0 : _o.accountName
    }];
    var autoPayPaymentDescription = [{
      title: translations.TotalPaymentAmount,
      value: "".concat(currencyFormatter('en-US', 'currency', 'USD', this.totalDraftAmountFun()))
    }, {
      title: translations.DraftDate,
      value: moments((_q = (_p = this.state) === null || _p === void 0 ? void 0 : _p.payment) === null || _q === void 0 ? void 0 : _q.effectiveDate).format("MM/DD/yyyy")
    }];
    var handleLinkPress = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var url, supported;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              url = 'https://mypennymac-qa.pennymac.com/Home/Terms/197';
              return [4 /*yield*/, Linking.canOpenURL(url)];
            case 1:
              supported = _a.sent();
              if (!supported) return [3 /*break*/, 3];
              return [4 /*yield*/, Linking.openURL(url)];
            case 2:
              _a.sent();
              return [3 /*break*/, 4];
            case 3:
              console.error("Don't know how to open \u00A0 \n         URI: ".concat(url));
              _a.label = 4;
            case 4:
              return [2 /*return*/];
          }
        });
      });
    };
    if (isLoading || !(currentLoan && (layout === null || layout === void 0 ? void 0 : layout.modLoaded) && (layout === null || layout === void 0 ? void 0 : layout.paymentModel) && originalNextPaymentDueDate)) {
      return /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: "coloumn",
          justifyContent: "center",
          alignItems: 'center',
          height: '100%'
        }
      }, /*#__PURE__*/React.createElement(PnmacActivityIndicator, null));
    }
    return /*#__PURE__*/React.createElement(PnmacMediaQuery, {
      onRefresh: function () {
        _this.props.authenticate(false);
      },
      refreshing: layout.reloadingData,
      queries: {
        small: "(max-width: 599px)",
        medium: "(min-width: 600px) and (max-width: 1199px)",
        large: "(min-width: 1200px)"
      }
    }, function (matches) {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
      return /*#__PURE__*/React.createElement(View, {
        id: "main-content",
        style: {
          paddingHorizontal: 0
        }
      }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, {
        className: "row"
      }, /*#__PURE__*/React.createElement(PnmacPaper, {
        disabled: true,
        style: styles.container
      }, /*#__PURE__*/React.createElement(TouchableOpacity, {
        style: styles.paymentMethodRow,
        onPress: function () {
          _this.setState({
            showSelectPaymentMethod: true
          });
        }
      }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('PaymentMethod'), {
        style: styles.paymentMethodTitle
      }), translations.PaymentMethod), /*#__PURE__*/React.createElement(View, {
        style: styles.rightContent
      }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('PaymentMethodValue'), {
        style: styles.paymentMethodTitle
      }), "".concat(((_b = (_a = paymentModel === null || paymentModel === void 0 ? void 0 : paymentModel.payment) === null || _a === void 0 ? void 0 : _a.bankAccount) === null || _b === void 0 ? void 0 : _b.bankAccountType) === 201286 ? translations.CheckingAccount : ((_d = (_c = paymentModel === null || paymentModel === void 0 ? void 0 : paymentModel.payment) === null || _c === void 0 ? void 0 : _c.bankAccount) === null || _d === void 0 ? void 0 : _d.bankAccountType) === 201287 ? translations.SavingsAccount : ((_f = (_e = paymentModel === null || paymentModel === void 0 ? void 0 : paymentModel.payment) === null || _e === void 0 ? void 0 : _e.bankAccount) === null || _f === void 0 ? void 0 : _f.bankAccountType) === 201288 ? "Debit Card" : "Add Account", " **"), (_j = (_h = (_g = paymentModel === null || paymentModel === void 0 ? void 0 : paymentModel.payment) === null || _g === void 0 ? void 0 : _g.bankAccount) === null || _h === void 0 ? void 0 : _h.accountNumber) === null || _j === void 0 ? void 0 : _j.slice(-4)), /*#__PURE__*/React.createElement(Image, {
        source: require("../../../../assets/back-chevron.png"),
        style: styles.chevronRight
      }))), /*#__PURE__*/React.createElement(View, {
        style: styles.divider
      }), /*#__PURE__*/React.createElement(TouchableOpacity, {
        style: styles.paymentMethodRow
      }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('PaymentAmount'), {
        style: styles.paymentMethodTitle
      }), translations.PaymentAmount), /*#__PURE__*/React.createElement(View, {
        style: styles.rightContent
      }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('MonthlyPaymentAmount'), {
        style: styles.totalPaymentAmountValue
      }), currencyFormatter('en-US', 'currency', 'USD', (_l = (_k = layout.paymentModel) === null || _k === void 0 ? void 0 : _k.payment) === null || _l === void 0 ? void 0 : _l.monthlyPaymentAmount)))), /*#__PURE__*/React.createElement(View, {
        style: styles.innerDivider
      }), /*#__PURE__*/React.createElement(View, {
        style: styles.inputContainer
      }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('AdditionalPrincipal'), {
        style: styles.paymentMethodTitle
      }), translations.AdditionalPrincipal), /*#__PURE__*/React.createElement(PnmacTextInput, __assign({}, testID('AdditionalPrincipalAmount'), {
        mode: "outlined",
        style: styles.input,
        placeholder: "$0.00",
        left: true,
        accessibilityLabel: "Additional principal",
        nativeID: "additionalPrincipalAmount",
        keyboardType: layout.mobile ? "decimal-pad" : "default",
        onBlur: function () {
          var _a, _b, _c;
          if (parseFloat(_this.replaceDollarSign((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.additionalPrincipalAmount) || 0.00) <= 0.01) {
            _this.onChange("$0.00", "additionalPrincipalAmount");
          } else {
            if (!isNaN(parseFloat(_this.replaceDollarSign((_b = _this.state.payment) === null || _b === void 0 ? void 0 : _b.additionalPrincipalAmount)))) {
              _this.onChange(parseFloat(_this.replaceDollarSign((_c = _this.state.payment) === null || _c === void 0 ? void 0 : _c.additionalPrincipalAmount)).toFixed(2), "additionalPrincipalAmount");
            }
          }
        },
        onFocus: function () {
          var _a;
          if (parseFloat(_this.replaceDollarSign((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.additionalPrincipalAmount) || 0) <= 0.01) {
            _this.onChange("$0.00", "additionalPrincipalAmount");
          }
        },
        returnKeyType: 'done',
        textAlign: 'left',
        value: "$".concat((_o = (_m = _this.state.payment) === null || _m === void 0 ? void 0 : _m.additionalPrincipalAmount) !== null && _o !== void 0 ? _o : 0),
        onChangeText: function (text) {
          var _a;
          var amount = _this.replaceDollarSign(text);
          if (((_a = amount || "") === null || _a === void 0 ? void 0 : _a.countDecimals()) <= 2) {
            _this.onChange(amount, "additionalPrincipalAmount");
          }
        }
      }))), /*#__PURE__*/React.createElement(View, {
        style: styles.totalPaymentAmountContainer
      }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('TotalPaymentAmount'), {
        style: styles.totalPaymentAmountTitle
      }), translations.TotalPaymentAmount), /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('TotalPaymentAmountValue'), {
        style: styles.totalPaymentAmountValue
      }), currencyFormatter('en-US', 'currency', 'USD', _this.totalDraftAmountFun()))), /*#__PURE__*/React.createElement(View, {
        style: styles.divider
      }), /*#__PURE__*/React.createElement(TouchableOpacity, {
        style: styles.paymentDateRow,
        onPress: function () {
          var _a, _b, _c, _d;
          return _this.props.navigation.navigate("AutoPayDate", {
            edit: true,
            autopayEnabled: autopayEnabled,
            selectedDateValue: ((_a = _this.state) === null || _a === void 0 ? void 0 : _a.effectiveDate) ? moment((_b = _this.state) === null || _b === void 0 ? void 0 : _b.effectiveDate).date() > 16 ? 1 : moment((_c = _this.state) === null || _c === void 0 ? void 0 : _c.effectiveDate).date() : 1,
            additionalPrincipalAmount: (_d = _this.state.payment) === null || _d === void 0 ? void 0 : _d.additionalPrincipalAmount,
            state: _this.state
          });
        }
      }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('MonthlyDraftDate'), {
        style: styles.paymentDateTitle
      }), translations.MonthlyDraftDate), /*#__PURE__*/React.createElement(View, {
        style: styles.rightContent
      }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('MonthlyDraftDateValue'), {
        style: styles.paymentDateTitle
      }), _this.getDate((_q = (_p = _this.props.route.params) === null || _p === void 0 ? void 0 : _p.AutoPayDate) !== null && _q !== void 0 ? _q : moment((_r = _this.state) === null || _r === void 0 ? void 0 : _r.effectiveDate).date())), /*#__PURE__*/React.createElement(Image, {
        source: require("../../../../assets/back-chevron.png"),
        style: styles.chevronRight
      })))), _this.checkPaymentOver() ? /*#__PURE__*/React.createElement(BannerView, {
        type: 'error',
        style: {
          marginTop: 10,
          marginHorizontal: 30
        }
      }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, _this.props, {
        layout: layout,
        value: translations === null || translations === void 0 ? void 0 : translations.DefaultPaymentsPayoffMessage
      }))) : null, edit && /*#__PURE__*/React.createElement(PnmacPaper, {
        style: styles.editContainer
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-around',
          paddingHorizontal: 32,
          paddingVertical: 15
        }
      }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Toogle, __assign({}, testID('AutoPayEnabledToggle'), {
        value: _this.state.autopayEnabled,
        onValueChange: function (updateToggle) {
          _this.setState({
            cancelAutopay: updateToggle,
            cancelModalOpen: true
          });
        },
        disabled: false
      }))), /*#__PURE__*/React.createElement(View, {
        style: {
          flex: 1,
          marginLeft: 14
        }
      }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('AutoPayEnabled'), {
        style: {
          color: '#6B6B6B',
          fontWeight: 'bold',
          fontSize: 16
        }
      }), translations.AutoPayEnabled), /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('AutopayActiveDescription'), {
        ellipsizeMode: "tail",
        style: {
          color: '#6B6B6B',
          fontSize: 12
        }
      }), translations.AutopayActiveDes)))), /*#__PURE__*/React.createElement(View, {
        style: styles.bottomContent
      }, /*#__PURE__*/React.createElement(PnmacUIButton, __assign({}, testID(edit ? 'UpdateAutoPayButton' : 'EnableAutopay'), {
        marginTop: 14.7,
        disabled: _this.disableSubmitButton() && !_this.state.isPaymentMethodUpdated,
        style: {
          width: '100%',
          height: 47,
          justifyContent: "center"
        },
        mode: "contained",
        onPress: function () {
          if (!_this.state.cancelModalOpen) {
            _this.getEffectiveDate();
            _this.setState({
              modalOpen: true
            });
          } else {
            _this.submitPayment();
          }
        }
      }), edit ? translations.UpdateAutoPayButton : 'ENABLE AUTOPAY'), /*#__PURE__*/React.createElement(BannerView, {
        type: 'info',
        style: styles.bottomInfoContainer
      }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('AchPaymentDescription'), {
        style: styles.paymentBottomInfo
      }), translations.AchPaymentDescription, " ", translations.IfDateFallsWeekend)))), /*#__PURE__*/React.createElement(PnmacModal, {
        open: _this.state.modalOpen && !_this.state.submitModalOpen,
        style: {
          paddingHorizontal: 1
        },
        "aria-label": "AutoPay Modal"
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          borderRadius: 8,
          backgroundColor: '#ffffff',
          marginVertical: 30
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          padding: 3
        }
      }, /*#__PURE__*/React.createElement(TouchableOpacity, __assign({}, testID('CloseIcon'), {
        style: {
          alignItems: 'flex-end',
          padding: 8
        },
        onPress: function () {
          _this.setState({
            modalOpen: false
          });
        }
      }), /*#__PURE__*/React.createElement(View, {
        style: {
          flexDirection: 'row'
        }
      }, /*#__PURE__*/React.createElement(Image, {
        source: imageAssets.closeIcon,
        style: {
          marginRight: 8,
          marginTop: 8
        }
      })))), /*#__PURE__*/React.createElement(View, {
        style: {
          display: 'flex',
          flexDirection: 'coloumn',
          alignItems: 'center',
          justifyContent: 'space-around',
          paddingHorizontal: 32,
          borderBottomColor: '#1B1B1B',
          borderBottomWidth: 0.5,
          paddingVertical: 15,
          paddingBottom: 20,
          marginLeft: 10,
          marginRight: 10
        }
      }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('AutoPayDetails'), {
        style: __assign(__assign({}, theme.textStyle.modalTitle), {
          fontFamily: "Montserrat",
          fontWeight: "bold",
          textAlign: 'center',
          fontSize: 22,
          color: "#333333",
          marginBottom: 10
        })
      }), "AutoPay Details"), /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('TotalDraftAmount'), {
        style: styles.paymentValue
      }), currencyFormatter('en-US', 'currency', 'USD', _this.totalDraftAmountFun())), /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('DraftDate'), {
        style: {
          fontFamily: "HalenoirCompactText-Medium",
          fontSize: 13,
          color: "#5C5C5C"
        }
      }), translations.DraftDate + ': ' + moments((_t = (_s = _this.state) === null || _s === void 0 ? void 0 : _s.payment) === null || _t === void 0 ? void 0 : _t.effectiveDate).format("MM/DD/yyyy"))), /*#__PURE__*/React.createElement(View, {
        style: {
          display: 'flex',
          borderBottomColor: '#1B1B1B',
          borderBottomWidth: 0.5,
          paddingBottom: 15,
          paddingTop: 15,
          marginLeft: 10,
          marginRight: 10
        }
      }, autoPayDescriptionContent.map(function (item, index) {
        return /*#__PURE__*/React.createElement(View, {
          key: index,
          style: styles.autoPayDetailsRow
        }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID(item.title.replace(/ /g, "")), {
          style: styles.autoPayDetailsDescriptionTitle
        }), item.title), /*#__PURE__*/React.createElement(View, {
          style: styles.rightContent
        }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID(item.title.replace(/ /g, "") + 'value'), {
          style: styles.autoPayDetailsDescriptionTitle
        }), item.value)));
      })), /*#__PURE__*/React.createElement(View, {
        style: {
          display: 'flex',
          borderBottomColor: '#1B1B1B',
          borderBottomWidth: 0.5,
          paddingBottom: 15,
          paddingTop: 15,
          marginLeft: 10,
          marginRight: 10
        }
      }, autoPayPaymentDescription.map(function (item, index) {
        return /*#__PURE__*/React.createElement(View, {
          key: index,
          style: styles.autoPayDetailsRow
        }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID(item.title.replace(/ /g, "")), {
          style: styles.autoPayDetailsDescriptionTitle
        }), item.title), /*#__PURE__*/React.createElement(View, {
          style: styles.rightContent
        }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID(item.title.replace(/ /g, "") + "value"), {
          style: styles.autoPayDetailsPaymentsTitle
        }), item.value)));
      })), /*#__PURE__*/React.createElement(View, {
        style: {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-around',
          paddingVertical: 15,
          paddingHorizontal: 8,
          marginLeft: 10,
          marginRight: 10
        }
      }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, __assign({
        ellipsizeMode: "tail"
      }, testID('ACHTermsDescription'), {
        style: __assign({}, styles.autoPayDetailsDescriptionTitle)
      }), translations.ACHTermsDescription, ' ', /*#__PURE__*/React.createElement(Text, __assign({}, testID('ACHTermsAgreement'), {
        style: __assign(__assign({}, styles.autoPayDetailsDescriptionTitle), {
          color: '#10719e'
        }),
        onPress: function () {
          handleLinkPress();
        }
      }), translations.ACHTermsAgreement)))), ((_w = (_v = (_u = layout.paymentModel) === null || _u === void 0 ? void 0 : _u.payment) === null || _v === void 0 ? void 0 : _v.bankAccount) === null || _w === void 0 ? void 0 : _w.accountNumber) && /*#__PURE__*/React.createElement(View, {
        style: {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-around',
          paddingHorizontal: 8,
          marginLeft: 10,
          marginRight: 10
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('BankInfoWarningMessage'), {
        ellipsizeMode: "tail",
        style: __assign(__assign({}, styles.autoPayDetailsDescriptionTitle), {
          textAlign: 'center'
        })
      }), translations.BankInfoWarningLine1, " ", currencyFormatter('en-US', 'currency', 'USD', _this.totalDraftAmountFun()), " ", translations.BankInfoWarningLine2, " ", (_z = (_y = (_x = layout.paymentModel) === null || _x === void 0 ? void 0 : _x.payment) === null || _y === void 0 ? void 0 : _y.bankAccount) === null || _z === void 0 ? void 0 : _z.accountNumber))), /*#__PURE__*/React.createElement(View, {
        style: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-around',
          paddingHorizontal: 8,
          paddingVertical: 15
        }
      }, /*#__PURE__*/React.createElement(PnmacUIButton, __assign({
        style: {
          width: '80%',
          height: 47,
          justifyContent: "center"
        }
      }, testID('SubmitButton'), {
        mode: "contained",
        onPress: function () {
          _this.setState({
            modalOpen: false
          });
          _this.submitPayment();
        }
      }), translations.SubmitButtonPnmacText), /*#__PURE__*/React.createElement(PnmacUIButton, __assign({
        marginTop: 15,
        style: {
          width: '80%',
          height: 47,
          justifyContent: "center"
        },
        mode: "outlined"
      }, testID('Cancel'), {
        onPress: function () {
          _this.setState({
            modalOpen: false
          });
        }
      }), translations.cancel)))), /*#__PURE__*/React.createElement(PnmacModal, {
        open: _this.state.submitModalOpen,
        style: {
          paddingHorizontal: 5
        },
        "aria-label": "AutoPay Application Submitted"
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          borderRadius: 8,
          backgroundColor: '#ffffff',
          marginVertical: 30
        }
      }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('ApplicationSubmitted'), {
        style: __assign(__assign({}, theme.textStyle.modalTitle), {
          fontFamily: "Montserrat",
          fontWeight: "bold",
          textAlign: 'center',
          fontSize: 22,
          paddingTop: 30,
          color: "#333333"
        })
      }), translations === null || translations === void 0 ? void 0 : translations.ApplicationSubmitted), /*#__PURE__*/React.createElement(View, {
        style: {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-around',
          paddingHorizontal: 32,
          paddingVertical: 15
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          flex: 1,
          marginLeft: 14
        }
      }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('AutoPaySubmittedMessage'), {
        ellipsizeMode: "tail",
        style: __assign(__assign({}, theme.textStyle.modalDesc), {
          color: '#6B6B6B',
          textAlign: 'center',
          fontSize: 13
        })
      }), translations === null || translations === void 0 ? void 0 : translations.AutoPaySubmittedMessageLine1))), /*#__PURE__*/React.createElement(View, {
        style: {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-around',
          borderBottomColor: '#1B1B1B',
          borderBottomWidth: 0.5,
          paddingHorizontal: 8,
          paddingVertical: 15
        }
      }, /*#__PURE__*/React.createElement(PnmacUIButton, __assign({
        marginTop: 15,
        style: {
          width: '80%',
          height: 47,
          justifyContent: "center"
        },
        mode: "contained"
      }, testID('Close'), {
        onPress: function () {
          _this.setState({
            submitModalOpen: false
          });
          _this.props.navigation.navigate("Payment/Pending");
        }
      }), translations === null || translations === void 0 ? void 0 : translations.Close)))), /*#__PURE__*/React.createElement(PnmacModal, {
        open: _this.state.cancelModalOpen,
        style: {
          paddingHorizontal: 5
        },
        "aria-label": "Cancel Service Edited"
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          borderRadius: 8,
          backgroundColor: '#ffffff',
          marginVertical: 30,
          paddingHorizontal: 30,
          paddingTop: 20
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          position: 'absolute',
          top: 5,
          right: 5
        }
      }, /*#__PURE__*/React.createElement(TouchableOpacity, __assign({}, testID('CloseIcon'), {
        style: {
          alignItems: 'flex-end',
          padding: 8
        },
        onPress: function () {
          _this.setState({
            cancelModalOpen: false
          });
          _this.props.navigation.navigate("BottomNavBar", {
            modalOpen: false
          });
        }
      }), /*#__PURE__*/React.createElement(View, {
        style: {
          flexDirection: 'row'
        }
      }, /*#__PURE__*/React.createElement(Image, {
        source: imageAssets.closeIcon,
        style: {
          marginRight: 8,
          marginTop: 8
        }
      })))), /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('CancelServiceEdited'), {
        style: __assign(__assign({}, theme.textStyle.modalTitle), {
          fontFamily: "Montserrat",
          fontWeight: "bold",
          textAlign: 'center',
          fontSize: 22,
          paddingTop: 30,
          color: "#333333"
        })
      }), translations.CancelServiceEdited), /*#__PURE__*/React.createElement(View, {
        style: {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-around',
          paddingVertical: 15
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('CancelServiceMessage'), {
        ellipsizeMode: "tail",
        style: __assign(__assign({}, theme.textStyle.modalDesc), {
          color: '#333333',
          textAlign: 'center',
          fontSize: 13
        })
      }), translations.CancelServiceMessageLine1, " ", "\n\n", translations.CancelServiceMessageLine2))), /*#__PURE__*/React.createElement(View, {
        style: {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-around',
          borderBottomColor: '#1B1B1B',
          paddingHorizontal: 8
        }
      }, /*#__PURE__*/React.createElement(PnmacUIButton, __assign({}, testID('ACHAlertModalYesCancelMyService'), {
        marginTop: 15,
        style: {
          height: 47,
          justifyContent: "center"
        },
        mode: "contained",
        onPress: function () {
          _this.submitPayment();
        }
      }), translations.ACHAlertModalYesCancelMyService)), /*#__PURE__*/React.createElement(View, {
        style: {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-around',
          borderBottomColor: '#1B1B1B',
          borderBottomWidth: 0.5,
          paddingHorizontal: 8,
          paddingVertical: 15
        }
      }, /*#__PURE__*/React.createElement(PnmacUIButton, __assign({}, testID('ACHAlertModalNo'), {
        style: {
          height: 47,
          justifyContent: "center"
        },
        mode: "outlined",
        onPress: function () {
          _this.setState({
            cancelAutopay: false,
            cancelModalOpen: false
          });
        }
      }), translations.ACHAlertModalNo))))));
    });
  };
  return SetupAutoPay;
}(Component);
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
var mapDispatchToProps = function (dispatch) {
  var Actions = require("../../../../redux/actions/actions.js");
  return __assign({
    dispatch: dispatch
  }, bindActionCreators(Actions, dispatch));
};
export default connect(mapStateToProps, mapDispatchToProps)(SetupAutoPay);
var styles = StyleSheet.create({
  container: {
    padding: 0,
    backgroundColor: "white",
    borderRadius: 7,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    marginHorizontal: 15,
    marginTop: 30
  },
  editContainer: {
    padding: 0,
    backgroundColor: "white",
    borderRadius: 7,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    marginHorizontal: 15,
    marginTop: 30
  },
  paymentMethodRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    height: 62.8,
    alignItems: "center",
    paddingLeft: 17.5,
    paddingRight: 14.5
  },
  paymentMethodTitle: {
    fontFamily: "HalenoirCompactText-Medium",
    fontSize: 14,
    color: "#5C5C5C"
  },
  divider: {
    height: 1,
    width: "100%",
    backgroundColor: "#CCCCCC"
  },
  innerDivider: {
    height: 1,
    width: "90%",
    backgroundColor: "#CCCCCC",
    alignSelf: "center",
    marginBottom: 20
  },
  rightContent: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: 'flex-end',
    flex: 0.8
  },
  chevronRight: {
    marginLeft: 7.9,
    width: 10,
    height: 10,
    transform: [{
      rotate: '180deg'
    }]
  },
  inputContainer: {
    marginHorizontal: 19
  },
  input: {
    height: 41,
    marginTop: 9.9
  },
  totalPaymentAmountContainer: {
    backgroundColor: "#F7F7F7",
    borderRadius: 5,
    height: 43,
    marginHorizontal: 18,
    marginTop: 19.1,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingLeft: 13.5,
    paddingRight: 14,
    marginBottom: 17.9
  },
  totalPaymentAmountTitle: {
    color: "#1B1B1B",
    fontFamily: "HalenoirCompactText-Medium",
    fontSize: 14
  },
  totalPaymentAmountValue: {
    color: "#117AAA",
    fontFamily: "HalenoirCompactText-Bold",
    fontWeight: "bold",
    fontSize: 14
  },
  paymentDateRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    height: 62.8,
    alignItems: "center",
    paddingLeft: 17.5,
    paddingRight: 14.5
  },
  paymentDateTitle: {
    fontFamily: "HalenoirCompactText-Medium",
    fontSize: 14,
    color: "#5C5C5C"
  },
  paymentBottomInfo: {
    fontFamily: "HalenoirCompactText-Medium",
    fontSize: 14,
    color: "#5C5C5C"
  },
  bottomInfoContainer: {
    marginTop: 15
  },
  bottomContent: {
    marginHorizontal: 15
  },
  paymentValue: {
    fontFamily: "Montserrat",
    fontWeight: "bold",
    fontSize: 32,
    color: "#117AAA",
    marginTop: 4.4,
    marginBottom: 10
  },
  autoPayDetailsRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingLeft: 5,
    paddingRight: 5
  },
  autoPayDetailsDescriptionTitle: {
    fontFamily: "HalenoirCompactText-Medium",
    fontSize: 13,
    color: "#5C5C5C",
    textAlign: 'center'
  },
  autoPayDetailsPaymentsTitle: {
    fontFamily: "HalenoirCompactText-Bold",
    fontSize: 14,
    color: "#117AAA"
  },
  togglecontainer: {
    justifyContent: 'center',
    alignContent: 'center'
  },
  inner: {
    width: 13,
    height: 13,
    backgroundColor: 'white',
    borderRadius: 15
  },
  outer: {
    width: 28,
    height: 18,
    borderRadius: 18,
    alignItems: 'center',
    flexDirection: 'row',
    padding: 3
  }
});